import { createContext } from 'react';
export const ModalContext = /*#__PURE__*/createContext({
  hasHeader: false,
  hasFooter: false,
  isSticky: false,
  isHeroHeader: false
});